import { useRef } from 'react';
import { useSpring, animated } from 'react-spring';
import { useWidth } from '../../CustomHooks';
import styles from './OverallCompletion.module.scss';

interface Props {
  title: string;
  handleClick: () => void;
  numComplete: number;
  totalNum: number;
  textButton: string;
  barColor: string;
  isExpanded?: boolean;
}

const OverallCompletion = ({
  title,
  handleClick,
  numComplete,
  totalNum,
  textButton,
  barColor,
  isExpanded,
}: Props): JSX.Element => {
  const ref = useRef<HTMLDivElement>(null);
  const barWidth = useWidth(ref);
  const overallProgressSpringProps = useSpring({
    from: { width: 0 },
    to: {
      width: barWidth !== null && barWidth !== 0 ? barWidth * (numComplete / totalNum) : 0,
    },
  });

  return (
    <div
      className={styles.container}
      style={{
        borderBottomRightRadius: isExpanded ? '0px' : '8px',
        borderBottomLeftRadius: isExpanded ? '0px' : '8px',
      }}
    >
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.incompleteBar} ref={ref}>
        <animated.div
          className={styles.completeBar}
          style={{
            backgroundColor: barColor,
            ...overallProgressSpringProps,
            borderTopRightRadius: numComplete / totalNum === 1 ? '4px' : 0,
            borderBottomRightRadius: numComplete / totalNum === 1 ? '4px' : 0,
          }}
        >
          {barWidth != null &&
            (barWidth * numComplete) / totalNum > 30 &&
            `${Math.floor((numComplete / totalNum) * 100)}%`}
        </animated.div>
      </div>
      <div className={styles.expandContainer}>
        <div
          className={styles.expandButton}
          onClick={handleClick}
          style={{
            color: '#012a73',
            borderBottomRightRadius: numComplete < totalNum ? '0' : '4px',
            borderTopRightRadius: numComplete < totalNum ? '0' : '4px',
          }}
          role='button'
        >
          {textButton}
        </div>
      </div>
    </div>
  );
};

export default OverallCompletion;
